var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.18 2.845l3.535 3.536-1.178 1.178-2.702-2.702v9.571H9.168v-9.57L6.466 7.558 5.287 6.381l3.536-3.536L10 1.667l1.179 1.178zM3.335 12.5H1.668v5.833h16.667V12.5h-1.667v4.167H3.335V12.5z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "e4e0bb33ac6187b263de70e7b0a8bedb.svg";
export { SvgShare as ReactComponent };